// sentry.ts (new file, imported before React renders)
import * as Sentry from "@sentry/react";

if (!Sentry.getCurrentScope().getClient()) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(),Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    enableLogs: true,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}